import {
  WEBSTORYBYID_FETCH_DATA_SUCCESS,
  WEBSTORYBYID_ARE_LOADING,
  WEBSTORYBYID_HAVE_ERROR,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";

// Action creator function to handle different types of home primary actions
export function webstorybyIDAction(action, payload) {
  switch (action) {
    case WEBSTORYBYID_HAVE_ERROR:
      return {
        type: action,
        hasError: payload,
      };

    case WEBSTORYBYID_ARE_LOADING:
      return {
        type: action,
        isLoading: payload,
      };

    case WEBSTORYBYID_FETCH_DATA_SUCCESS:
      return {
        type: action,
        homePrimary: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch home primary data
export function WebStorybyIDFetchData(slug) {
  return (dispatch) => {
    try {
      // Dispatch action indicating data is loading
      dispatch(webstorybyIDAction(WEBSTORYBYID_ARE_LOADING, true));

      // Check if home primary data is available in local storage
      if (localStorage.getItem("SandeshHome")) {
        // If available, dispatch action with data from local storage
        dispatch(
          webstorybyIDAction(
            WEBSTORYBYID_FETCH_DATA_SUCCESS,
            JSON.parse(localStorage.getItem("SandeshHome"))
          )
        );
      }

      // Fetch home primary data using GET request
      return new Promise((resolve, reject) => {
        Get(HttpService.WebStoryById + "?url=" + slug).then(
          (result) => {
            // Store fetched data in local storage
            localStorage.setItem("SandeshHome", JSON.stringify(result.data));
            // Dispatch action with fetched home primary data
            dispatch(
              webstorybyIDAction(WEBSTORYBYID_FETCH_DATA_SUCCESS, result.data)
            );
            resolve(result);
          },
          (error) => {
            reject(error); // Reject promise with error if fetching fails
          }
        );
      });
    } catch (error) {
      // Dispatch action if there's an error in fetching data
      dispatch(webstorybyIDAction(WEBSTORYBYID_HAVE_ERROR, true));
    }
  };
}
